<template>
    <AppLayout>
        <div class="bg-white">
            <!-- Hero -->
            <div class="bg-[#17364a] py-16">
                <div class="mx-auto max-w-7xl px-6 lg:px-8">
                    <nav aria-label="Breadcrumb" class="mb-4">
                        <ol role="list" class="flex items-center space-x-2">
                            <li v-for="breadcrumb in page.breadcrumbs" :key="breadcrumb.id" class="flex items-center">
                                <a :href="breadcrumb.href" class="text-xs text-gray-400 hover:text-white">{{ breadcrumb.name }}</a>
                                <span class="mx-2 text-gray-600">/</span>
                            </li>
                            <li class="text-xs text-gray-300">{{ page.name }}</li>
                        </ol>
                    </nav>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-3 block">Books</span>
                    <h1 class="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{{ page.name }}</h1>
                </div>
            </div>

            <!-- Content -->
            <div class="mx-auto max-w-7xl px-6 lg:px-8 py-12 lg:py-16">
                <div v-for="book in books" class="mb-16" :key="book.id">
                    <div class="grid items-start grid-cols-1 lg:grid-cols-2 gap-10">
                        <div class="overflow-hidden border border-[#E5E5E5]">
                            <img :src="book.thumbnail" alt="Book cover"
                                class="w-full aspect-[3/4] object-cover object-top hover:scale-[1.02] transition-all duration-300" />
                        </div>

                        <div class="py-6">
                            <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-3 block">Book</span>
                            <h2 class="text-2xl font-bold text-[#17364a]">{{ book.title }}</h2>
                            <p class="mt-4 text-sm text-gray-500 leading-relaxed">{{ book.description }}</p>

                            <div class="mt-8">
                                <p class="text-4xl font-extrabold text-[#17364a]">${{ book.price }}</p>
                            </div>

                            <div class="mt-8">
                                <Button
                                    class="w-full sm:w-auto"
                                    style="background: #17364a; border: none; border-radius: 0; font-weight: 600; padding: 0.875rem 2rem;"
                                    @click="() => $router.push({ name: 'books.checkout', params: { id: book.id } })">
                                    Buy Now
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import { ref } from 'vue';
import { getBooks } from '@/services/bookService.js';
import Button from 'primevue/button';

const books = ref(null);

const fetchBooks = async () => {
    const response = await getBooks();
    books.value = response.data;
}

fetchBooks();

const page = {
    name: 'Books',
    breadcrumbs: [
        { id: 1, name: 'Home', href: '/' },
    ],
}
</script>
